import React from 'react'
import FacultyHistoryTools from './FacultyHistoryTools'
import { DataGrid } from '@mui/x-data-grid';
import { useState } from 'react';
import { useEffect } from 'react';
import { FacultyHistoryShowdata } from '../../services/LoginPageService';

const FacultyHistory = () => {
  const [rows,setRow]=useState([]);
  const [isAddButton, setIsAddButton] = useState(true);
  const [editStudent, setEditStudent] = useState('');
  const [open, setOpen] = useState(false);
  const [open1, setOpen1] = useState(false);
  const [open2, setOpen2] = useState(false);
  const [dataForQR,setDataForQr]= useState('');
  const [refreshData, setRefreshData] = useState(false);
  const [isLoading, setGridLoading] = useState(true);
  const [deleteId,setDeleteId]=useState('');
  const [deleteDailogOpen,setDeleteDailogOpen]= useState(false);
  const [openNotification, setNotification] = useState({
    status: false,
    type: 'error',
    message: '',
  });
  
  const columns = [
    {
      field: 'facultyId',
      headerName: 'Faculty Id',
      headerClassName: 'super-app-theme--header',
      minWidth: 100, flex: 1, align: 'center', headerAlign: 'center'
    },
    {
      field: 'facultyName',
      headerName: 'Faculty Name',
      headerClassName: 'super-app-theme--header',
      minWidth: 100, flex: 1, align: 'left', headerAlign: 'center'
    },
    {
      field: 'location',
      headerClassName: 'super-app-theme--header',
      headerName: 'Location',
      minWidth: 100, flex: 1, align: 'left', headerAlign: 'center'
    },
    {
      field: 'gender',
      headerName: 'Gender',
      headerClassName: 'super-app-theme--header',
      minWidth: 100, flex: 1, align: 'left', headerAlign: 'center'
    },
    {
      field: 'contactNo',
      headerName: 'Contact No',
      headerClassName: 'super-app-theme--header',
      minWidth: 100, flex: 1, align: 'center', headerAlign: 'center'
    },
    {
      field: 'emailId',
      headerName: 'Email Id',
      headerClassName: 'super-app-theme--header',
      minWidth: 100, flex: 1, align: 'left', headerAlign: 'center'
    },
  ];

  useEffect(()=>{
    FacultyHistoryShowdata(handleFacultyHistoryShow,handeFacultyHistoryException);
  },[refreshData]);
      
  const handleFacultyHistoryShow=(dataObject)=>{
    setGridLoading(false);
    setRow(dataObject?.data || []);
  }

  const handeFacultyHistoryException=(errorStatus, errorMessage)=>{
    console.log(errorMessage);
  }
  
  return (
    <div>
      <FacultyHistoryTools 
      setIsAddButton={setIsAddButton}
      editStudent={editStudent}
      setOpen={setOpen}
      setOpen2={setOpen2}
      setEditStudent={setEditStudent}/>

      <DataGrid
        rows={rows}
        columns={columns}
        pageSize={8}
        loading={isLoading} 
        rowsPerPageOptions={[8]}
        disableSelectionOnClick
        sx={{
          height: '480px',
          width: '100%',
          '& .super-app-theme--header': {
            WebkitTextStrokeWidth:'0.6px',
          
          },
        }}
      />
    </div>
  )
}

export default FacultyHistory
